<template>
    <div>
      <div id="manageComplianceDetails" class="modal" role="dialog">
        <div class="modal-dialog modal-lg custom-view-history-modal-class">
          <!-- Modal content-->
          <div class="modal-content manageComplianceDetailsModal">
            <div class="modal-header d-flex">
              <div class="manage-compliance-title-text" :title="details.certificateNumber">{{ details.certificateNumber }}</div>
              <div class="close-icon">
                <img src="/static/images/icons/ul_close_icon.svg" data-dismiss="modal">
              </div>
            </div>
            <div class="header-hr-outer" :class="{'pt-26':!details.certificateNumber}">
              <hr class="hr-line"/>
            </div>
            <div class="modal-body">
              <div class="container-fluid p-0">
                <div class="col-md-12 col-sm-12 p-0">
                    <div class="col-md-6 col-sm-6 p-0">
                      <div class="col-md-6 col-sm-6 red-text-section">
                        <div  v-if="details.issueSeverity" class="red-text">{{ details.issueSeverity.toUpperCase() }}</div>
                        <div class="expires-in">{{$t('expiresIn')}}</div>
                        <div class="red-text">{{ details.resolve}} {{$t('days')}}</div>
                      </div>
                    </div>
                    <div class="col-md-6 col-sm-6 d-flex justify-content-end download-btn-section" v-if="roleId!==roleInfo['RA Viewer']">
                      <button type="button" class="btn btn-block blue_outline_download_button" @click="pdfFileDownload(details.registration_id)">
                        <img class="download-icon" src="/static/images/icons/new_download_icon.svg" alt="download-icon"/>{{$t('download')}}</button>
                    </div>
                </div>
                <div class="col-md-12 col-sm-12 body-hr-outer">
                  <hr/>
                </div>
                <div class="col-md-12 col-sm-12 table-header">
                  <div class="col-md-4 col-sm-4 p-0 purple-text">{{$t('dateCreated')}}</div>
                  <div class="col-md-4 col-sm-4 p-0 purple-text">{{$t('expirationDate')}}</div>
                </div>
                <div class="col-md-12 col-sm-12 table-body">
                  <div class="col-md-4 col-sm-4 p-0 table-body-text">{{ formatDate(details.createdOn) }}</div>
                  <div class="col-md-4 col-sm-4 p-0 table-body-text">
                    <span v-if="details.expirationDate">{{ formatDate(details.expirationDate) }}</span>
                    <span v-else>--</span>
                    </div>
                </div>
                <div class="col-md-12 col-sm-12 body-hr-outer">
                  <hr/>
                </div>
                <div class="col-md-12 col-sm-12 purple-text certificate-link-header">{{$t('certificateURL')}}</div>
                <div class="col-md-12 col-sm-12 table-body-text certificate-link"><a style="color:#333333" :href="details.certificateURL" target="_blank">{{ details.certificateURL }}</a></div>
                <div class="col-md-12 col-sm-12 body-hr-outer">
                  <hr/>
                </div>
                <div class="col-md-12 col-sm-12 purple-text certificate-link-header">{{$t('standards')}}</div>
                <div v-if="details.standards" class="col-md-12 col-sm-12 table-body-text standards-text" :title="details.standards">{{ details.standards }}</div>
                <div v-else class="col-md-12 col-sm-12 table-body-text standards-text">--</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
import * as moment from 'moment';
import { pdfFileDownload } from '../../utils/pdf-file-download';

export default {
  props: {
    details: Object,
    roleId: Number,
    roleInfo: Object
  },
  data() {
    return {
    };
  },

  methods: {
    formatDate(date) {
      return this.$i18n.locale === 'Portuguese' ? moment(date).format('DD/MM/YYYY') : moment(date).format('MM/DD/YYYY');
    },
    async pdfFileDownload(id) {
      pdfFileDownload(`${process.env.VUE_APP_JAVA_API_URL}/downloadManageCompliancePDF?id=${id}`);
    },
  },
};
</script>

<style scoped>
.pt-26 {
  padding-top:26px;
}
.expires-in {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #3E3E3E;
}
.certification-mark {
  display: flex;
  justify-content: center;
  padding-right: 45px;
}
.manageComplianceDetailsModal .modal-header{
    background: #FFFFFF !important;
    border-bottom: none !important;
    padding: 0px !important;
    border-radius: 8px;
}
.manageComplianceDetailsModal .manage-compliance-title-text{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 27px;
    color: #1A1A1A;
    padding: 17px 0px 16px 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 850px;
}
.manageComplianceDetailsModal .close-icon{
  position: absolute;
  right: 23px;
  top: 18px;
}
.manageComplianceDetailsModal .close-icon img{
  cursor: pointer;
}
.manageComplianceDetailsModal .header-hr-outer {
    /* padding: 0px 24px 0px 24px; */
}
.manageComplianceDetailsModal .header-hr-outer hr{
  margin: 0px !important;
  border-top:1px solid #D3D3D3;
}
.manageComplianceDetailsModal .body-hr-outer {
    padding: 22px 19px 24px 17px;
}
.manageComplianceDetailsModal .body-hr-outer hr{
    margin: 0px !important;
    border-top: 1px solid #D3D6D9;
    opacity: 0.55;
}
.red-text-section{
  padding: 6px 0px 0px 17px;
}
.purple-text-section{
  padding: 15px 0px 0px 0px;
}
.red-text{
  font-weight: 600;
  font-size: 20px;
  line-height: 27px;
  color: #B00505;
}
.purple-text{
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E;
}
.download-btn-section{
  padding: 8px 12px 0px 0px;
}
.blue_outline_download_button,
.blue_outline_download_button:hover,
.blue_outline_download_button:focus{
  background-color: #01518A;
  /* border: 1px solid #000000; */
  /* height: 44px; */
  max-width: 160px;
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 600;
  border-radius: 3px;
  line-height: 22px;
  padding:6px 16px 6px 21px;
  display: flex;
  align-items: center;
  justify-content: center;

}
.download-icon {
  margin-right: 8px;
}
.table-header{
  padding: 0px 0px 9px 17px;
}
.table-body,
.certificate-link-header{
  padding: 0px 0px 0px 17px;
}
.table-body-text{
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #333333;
}
.certificate-link{
  padding: 9px 0px 0px 17px;
}
.standards-text{
  padding: 9px 0px 8px 17px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 850px;
}
@media (min-width: 992px){
  .modal-lg {
    width: 900px !important;
  }
}
/* @media (min-width: 992px){
  .modal-lg {
    width: 600px !important;
  }
} */
</style>
